import axios from 'axios';

import { getApiUrl, API_ENDPOINTS, API_BASE_URL } from "../config/api";

let refresh = false;

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    // Prevent interceptor from running on login or refresh token endpoints
    const originalRequestUrl = error.config ? error.config.url : '';
    if (originalRequestUrl.includes(API_ENDPOINTS.LOGIN) || originalRequestUrl.includes(API_ENDPOINTS.REFRESH_TOKEN)) {
      return Promise.reject(error);
    }

    if (error.response && error.response.status === 401 && !refresh) {
      refresh = true;
      const refreshToken = localStorage.getItem('refresh_token');
      try {
        const response = await axios.post(
          getApiUrl(API_ENDPOINTS.REFRESH_TOKEN),
          { refresh: refreshToken },
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
            withCredentials: true,
          }
        );
        if (response.status === 200) {
          axios.defaults.headers.common[
            'Authorization'
          ] = `Bearer ${response.data.access}`;
          localStorage.setItem('access_token', response.data.access);
          
          // Only update refresh token if the backend provides a new one
          if (response.data.refresh) {
            localStorage.setItem('refresh_token', response.data.refresh);
          }
          refresh = false;
          
          // Update the failed request's Authorization header and retry
          error.config.headers['Authorization'] = `Bearer ${response.data.access}`;
          return axios(error.config);
        }
      } catch (refreshError) {
        // Handle any errors during token refresh if needed
        console.error('Error refreshing token:', refreshError);
        // Clear local storage and redirect to login if refresh fails
        localStorage.clear();
        window.location.href = '/';
      }
    }
    refresh = false;
    return Promise.reject(error);
  }
);